import { commonjsGlobal as a } from "./index61.js";
import "./index178.js";
import "./index179.js";
import { __exports as f } from "./index180.js";
import { __exports as _ } from "./index181.js";
var s = a && a.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
}, n = s(f), l = _;
function o(t, u) {
  var r = {};
  return !t || typeof t != "string" || (0, n.default)(t, function(i, e) {
    i && e && (r[(0, l.camelCase)(i, u)] = e);
  }), r;
}
o.default = o;
var x = o;
export {
  x as c
};
